/**
 * Sprint-1 placeholder surface. Every role-nav destination renders this
 * until its real screen is built in a later sprint. It exists so the
 * shell + auth + design system are reviewable end-to-end without
 * implying any later-sprint feature is done.
 */
import { Box, EmptyNote } from '../components/ui';

export default function Placeholder({ name }: { name: string }) {
  return (
    <Box title={name} note="Sprint 1 — surface reserved">
      <EmptyNote title={`${name} lands in a later sprint`}>
        The design-system foundation, role-based shell and Gmail/Apple auth
        are live. This screen is intentionally a placeholder — it will be
        built when its sprint is authorised.
      </EmptyNote>
    </Box>
  );
}
